import React, { useEffect, useState, useContext } from "react";
import "../admin/admin.css";
import { Link, Outlet, useHref, useNavigate, useParams } from "react-router-dom";
import Application from "./StateContext/Application";
import { useLanguage } from "../../lang/langcontext/LanguageContext";
import '../Users/pages/innercss.css'
import { host } from '../../path'
import { BankofMaharashtraLogo256, BillApprovals32, CreateDepartment32, CreateEmployee32, CreateRole32, Dashboard32, EditRoles32, EditViewEmp, EmployeeManagement32, logout, Master32, MISReports32, navimg, Profile, Report32, Vadhavan, VadhvanLogo256, VendorManagement32, GRManagement32, CreateGR, ViewGR, ADDLimit32, LimitAllocation32, GRApprovals32, GRDraftList32, GROutwards32, LimitOutwards32, LimitAllocationInwardListHeadwise32, LimitAllocationInwardListProposalWise, ProposalInwardStateWise32, DemandRequestInwardList32, AdministrativApprovalOutward32, AdministrativeApprovalCreation64, DemandRequest32 } from "../../public/LoginImages/importimages";

const menuImages = {
  Dashboard: "/Dashboard32.png",
  "GR Management": GRManagement32,
  "Create GR": CreateGR,
  "View GR": ViewGR,
  "Add Limit Allocation(Head Wise)": ADDLimit32,
  "GR Draft List": GRDraftList32,
  "Limit Allocation": LimitAllocation32,
  "GR Approvals": GRApprovals32,
  "GR Outwards": GROutwards32,
  "Limit Outward": LimitOutwards32,
  "Limit Allocation Inward List ( Head wise )": LimitAllocationInwardListHeadwise32,
  "Limit Allocation Inward List ( Proposal Wise )": LimitAllocationInwardListProposalWise,
  "Proposal Inward (State Wise)": ProposalInwardStateWise32,
  "Demand Request Inward List": DemandRequestInwardList32,
  "Administrative Approval Outward": AdministrativApprovalOutward32,
  "Demand Request": DemandRequest32,
  "Administrative Approval Creation": AdministrativeApprovalCreation64,
  "Project Dashboard": "/Project-Dashboard32.png",
  "Bill Creation": "/Bill-Creation32.png",
  "Bill Approvals": BillApprovals32,
  "Proposal Management": "/Proposal-Management32.png",
  "Employee Management": EmployeeManagement32,
  "MIS Reports": MISReports32,
  Master: "/Master32.png",
  Report: "/Report32.png",
  "Vendor Management": "/Vendor-Management32.png",
  "Work Order Management": "/Work-Order-Management32.png",
  "Create Department": CreateDepartment32,
  "Create Role": CreateRole32,
  "Create Employee": CreateEmployee32,
  "Edit View Emp": EditViewEmp,
  "Edit Roles": EditRoles32,
  "Technical Sanction": "/Technical-Sanction32.png",
  "Progress Report": "/Progress-Report32.png",
  "Proposal Outwards": "/Proposal-Outwards32.png",
  "Technical Sanction Outwards": "/Technical-Sanction-Outwards32.png",
  "Work Order Outwards": "/Work-Order-Outwards32.png",
  "Scheme Management": "/Scheme-Management32.png",
  "MIS Report": "/MIS-Report32.png",
  "Bill Outwards": "/Bill-Outwards32.png",
  "Progress Report Inward List": "/Progress-Report-Inward-List32.png",
  "Proposal Inwards List": "/Proposal-Inwards-List32.png",
  "Work Order Inwards List": "/Work-Order-Inwards-List32.png",
  "Administrative Approval Inwards": "/Administrative-Approval-Inwards32.png",
  "Bill Approvals": "/Bill-Approvals32.png",

  "Proposal Status": "/Proposal-Outwards32.png",
  "Technical Sanction Status": "/Technical-Sanction-Outwards32.png",
  "Work Order Status": "/Work-Order-Outwards32.png",
  "Bill Status": "/Bill-Outwards32.png",
  "GR Status": GROutwards32,
  "Limit Status": LimitOutwards32,
  "Progress Report Status": "/Progress-Report32.png",
  "Demand Request Status": DemandRequest32,
};

const AdminNavbar = () => {
  const navigate = useNavigate("");
  const statecalls = useContext(Application);
  const { Usermenu, NotificationHandler } = statecalls;
  const { language, toggleLanguage, t } = useLanguage();
  const [panel, setpanel] = useState("showpanel");
  let check = localStorage.getItem("Token");
  const [renderdata, SetRenderdata] = useState([]);
  const [loading, setloading] = useState(true)
  const [openMenus, setOpenMenus] = useState({});
  const para = useHref()
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);


  const [activeMenu, setActiveMenu] = useState(4);

  const handleMenuClick = (menuId, e) => {
    setActiveMenu(menuId);
    showoptions(e);
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `.hide-scrollbar::-webkit-scrollbar {display: none;}
        .hide-scrollbar {-ms-overflow-style: none;scrollbar-width: none;}`;
    document.head.appendChild(style);
  }, []);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 10000); // every 10 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchNotifications = async () => {
    try {
      const res = await NotificationHandler("fetch", null);
      if (res?.success && Array.isArray(res.data)) {
        setNotifications(res.data);
      } else {
        setNotifications([]);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  };

  useEffect(() => {
    try {
      if (!check) {
        navigate('/adminlogin')
        window.location.href = '/adminlogin'
      }
      getmenu()
    } catch (error) {
      console.error('Error in AdminNavbar useEffect:', error);
    }
  }, [])

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      SetRenderdata(await data);
      setloading(false);
      if (data) {
        console.log("data", data);
        let validationlink = window.location.pathname
        if (!data || typeof data !== "object") {
          console.error("Invalid data:", data);
          return [];
        }
        const menuArray = Array.isArray(data.result) ? data.result : [];
        // console.log("menu :: " , menuArray);
        let check = menuArray.filter((check) => {
          return (
            check.Link === validationlink
          )
        });
        if (check[0] === undefined) {
          alert('you are not allowed to access this link')
          navigate(data[0].Link)
        }
      }
    } catch (error) {
      console.error('Error in AdminNavbar getmenu:', error);
    }
  }

  const sidepanel = () => {
    if (panel === "showpanel") {
      setpanel("panel");
    } else {
      setpanel("showpanel");
    }
  };

  const showoptions = (e) => {
    try {
      let k = document.getElementById(e.currentTarget.value);
      if (k == null) { return }
      if (k.style.display == 'none') {
        k.style.display = 'block'
      } else {
        k.style.display = 'none'
      }
    } catch (error) {
      console.error('Error in AdminNavbar showoptions:', error);
    }
  }
  var audio = new Audio('https://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg');

  // Toggle menu visibility
  const toggleMenu = (menuId) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuId]: !prevState[menuId],
    }));
  };

  // const renderMenu = (menuList, parentId = 0, depth = 0) => {
  //   return menuList
  //     .filter((menu) => menu.Summenuid === parentId)
  //     .map((menu) => {
  //       const iconSrc = menuImages[menu.Menu_Name] || Dashboard32;
  //       const hasSubmenus = menuList.some((sub) => sub.Summenuid === menu.Menu_ID);
  //       const isNested = depth > 0; // Real depth-based submenus
  //       const liStyle = {
  //         paddingLeft: isNested ? "30px" : "10px",
  //         backgroundColor: isNested ? "#eaf6ff" : "transparent",
  //         borderLeft: isNested ? "3px solid #0098d5" : "none",
  //         marginBottom: "4px",
  //         borderRadius: isNested ? "6px" : "0",
  //       };
  //       const linkStyle = {
  //         display: "flex",
  //         alignItems: "center",
  //         padding: "6px 10px",
  //         fontWeight: 500,
  //         color: isNested ? "#003366" : "white",
  //         backgroundColor: isNested ? "#eaf6ff" : "transparent",
  //         borderRadius: isNested ? "6px" : undefined,
  //       };

  //       return (
  //         <li key={menu.Menu_ID} style={liStyle}>
  //           {hasSubmenus ? (
  //             <div
  //               onClick={() => toggleMenu(menu.Menu_ID)}
  //               style={{
  //                 cursor: "pointer",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 padding: "6px 10px",
  //               }}
  //             >
  //               {depth === 0 && (
  //                 <img
  //                   src={iconSrc}
  //                   alt={menu.Menu_Name}
  //                   style={{ width: "20px", height: "20px", marginRight: "8px" }}
  //                 />
  //               )}
  //               <span className="list-group-item listchange" style={{ fontWeight: 500, color: depth === 0 ? "white" : "#003366" }}>
  //                 {menu.Menu_Name}
  //               </span>
  //             </div>
  //           ) : (
  //             <Link to={menu.Link} className="list-group-item listchange" style={linkStyle}>
  //               {depth === 0 && (
  //                 <img
  //                   src={iconSrc}
  //                   alt={menu.Menu_Name}
  //                   style={{ width: "20px", height: "20px", marginRight: "8px" }}
  //                 />
  //               )}
  //               {menu.Menu_Name}
  //             </Link>
  //           )}

  //           {/* Recurse if submenu exists and is toggled open */}
  //           {hasSubmenus && openMenus[menu.Menu_ID] && (
  //             <ul style={{ paddingLeft: "0px", display: "block" }}>
  //               {renderMenu(menuList, menu.Menu_ID, depth + 1)}
  //             </ul>
  //           )}
  //         </li>
  //       );
  //     });
  // };

  const LogoutFunction = () => {
    sessionStorage.removeItem('createTechnicalForm');
    sessionStorage.removeItem('createProposalForm');
    localStorage.clear();
  }

  return (
    <>
      <div style={{ display: "flex" }}>
        {/* This is sidePanel */}
        <div className={panel} style={{ boxShadow: "2px", animation: "fadeIn 1s ease-in-out" }}>
          <div className="card hide-scrollbar" style={{ width: "16.5rem", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "start", background: 'linear-gradient(to bottom, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: "none", overflowY: "scroll" }}>
            <div className="col-12">
              <div className="col-12 mt-3 mb-0 py-0" style={{ display: "flex", justifyContent: "center", padding: "1rem", }}>
                <img src={VadhvanLogo256} className="card-img-top" alt="..." style={{ width: "7.5rem", height: "7.5rem", alignSelf: "center" }} />
              </div>
            </div>
            <ul className="list-group list-group-flush" style={{ border: "none", fontWeight: '400', padding: '0px 0px 0px 22px', overflowX: "visible", width: "95%" }}>
              {loading ? (
                <div className="loader m-auto"></div>
              ) : (
                Array.isArray(renderdata.result) ? (
                  renderdata.result.map((e, index) => {
                    if (!e.Summenuid) {
                      return (
                        <li className={`hovereffect ${activeMenu === e.Menu_ID ? "active-menu" : ""}`} style={{ width: "100%" }} key={e.Menu_ID} value={e.Menu_ID}
                          // onClick={(e) => showoptions(e)}
                          onClick={(event) => handleMenuClick(e.Menu_ID, event)}
                        >
                          <Link to={e.Link} className="list-group-item  listchange" >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <img src={menuImages[e.Menu_Name] || Dashboard32} alt={e.Menu_Name} style={{ width: "18px", height: "18px", marginRight: "8px" }} />
                              <span>{e.Menu_Name}</span>
                            </div>
                            <ul id={e.Menu_ID} style={{ display: 'none', width: "100%" }}>
                              {renderdata.result.map((x) => {
                                if (e.Menu_ID === x.Summenuid) {
                                  return (
                                    <Link key={x.Link} to={x.Link} style={{ textDecoration: 'none', color: "white" }}>
                                      <li className={`hovereffect ${activeMenu === x.Menu_ID ? "active-menu" : ""}`}
                                        style={{ padding: "6px 10px", width: "10.5rem", fontSize: '13px' }} onClick={() => setActiveMenu(x.Menu_ID)}
                                      >{x.Menu_Name}</li>
                                    </Link>
                                  )
                                }
                              })}
                            </ul>
                          </Link>
                        </li>
                      )
                    }
                  })
                ) : <a key={5678} style={{ color: 'white' }}>Kindly Refresh</a>
              )}
              <div className="mx-5 my-5 btn1 hovereffect" style={{ display: 'flex', alignItems: 'center', padding: '5px', width: '7rem', justifyContent: 'center', textAlign: 'center', borderRadius: '6px', background: 'linear-gradient(to Right, #F15E48 , #F07F2C , #F08B22 , #F19E13 )' }}>
                <Link to='/AdminLogin'>
                  <button onClick={() => LogoutFunction()} style={{ background: 'none', border: 'none', color: 'white' }}>
                    <b style={{ fontSize: "15px", fontWeight: "600" }}>
                      <img style={{ width: '19px', paddingBottom: '4px' }} src={logout} alt="Logout Icon" /> Logout
                    </b>
                  </button>
                </Link>
              </div>
            </ul>
            <div style={{ marginTop: 'auto', height: '100px', backgroundImage: `url(${navimg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '100%' }}></div>
          </div>
        </div >
        {/* this is navebar */}
        <div style={{ width: "100%", overflowX: 'hidden' }}>
          <nav className="navbar navbar-static-top" id="imgcss" style={{ backgroundColor: "#f4f7fe", display: "flex", flexWrap: "wrap", padding: '10px 30px 10px 0px', overflowY: 'hidden' }}>
            <a onClick={sidepanel} href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" style={{ color: "rgb(6 79 207)", textDecoration: "none", marginLeft: "1rem", }}>
              <i className="fa-solid fa-sliders"></i>
              <span className="py-2" style={{ background: 'linear-gradient(to Right, #F15E48 , #F07F2C , #F08B22 , #F19E13 )', color: "white", padding: "5px", marginLeft: "5px", border: "1px", border: "none", borderRadius: "8px", fontWeight: '500' }}> {para.slice(1)} </span>
            </a>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div><img src={BankofMaharashtraLogo256} /></div>
              <div style={{ display: 'flex', alignItems: 'center', height: '2.7rem', backgroundColor: "white", borderRadius: '24px', padding: '10px', justifyContent: 'center', gap: '0.5rem', boxShadow: '0px 0px 2px' }}>
                <img src={Profile} />
                <span style={{ color: "black", textTransform: "capitalize" }}>{renderdata ? `Welcome ${renderdata?.Data?.FullName}` : ''}</span>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <span style={{ fontWeight: "500" }}><p className="my-auto">{t("Language")} :</p></span>
              <button onClick={() => toggleLanguage("en")} style={{ background: "rgba(245, 123, 0, 0)", color: "#000000ff", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: "5px", fontWeight: "600" }}>English</button>
              <span>|</span>
              <button onClick={() => toggleLanguage("mr")} style={{ background: "rgba(245, 123, 0, 0)", color: "#000000ff", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: "5px", fontWeight: "600" }}>Marathi
              </button>
            </div>
            {/* 🔔 Notification Section */}
            <div style={{ marginLeft: '15px', position: 'relative' }}>
              <button onClick={() => setShowNotifications(!showNotifications)} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'relative' }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2">
                  <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 01-3.46 0" />
                </svg>
                {notifications.length > 0 && (
                  <span style={{ position: 'absolute', top: '-4px', right: '-4px', background: 'red', color: 'white', borderRadius: '50%', padding: '2px 6px', fontSize: '10px' }}>{notifications.length}</span>
                )}
              </button>
              {/* Dropdown list */}
              {showNotifications && (
                <div style={{ position: 'fixed', top: '35px', right: '50px', background: 'white', boxShadow: '0 2px 6px rgba(0,0,0,0.2)', borderRadius: '6px', width: '320px', maxHeight: '300px', overflowY: 'auto', zIndex: 999 }}>
                  {notifications.length > 0 ? (
                    <>
                      <div style={{ padding: '8px 10px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f9f9f9' }}>
                        <span style={{ fontWeight: 600 }}>Notifications</span>
                        <button onClick={async () => { await NotificationHandler("markAll"); fetchNotifications(); }} style={{ background: '#28a745', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', fontSize: '12px', cursor: 'pointer' }}>Mark All as Read</button>
                      </div>
                      {notifications.map((n, i) => (
                        <div key={i} style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ flex: 1, marginRight: '10px' }}>{n.Message}</span>
                          <button onClick={async () => { await NotificationHandler("markOne", n.id); fetchNotifications(); }} style={{ background: '#007bff', color: 'white', border: 'none', borderRadius: '4px', padding: '3px 6px', fontSize: '11px', cursor: 'pointer' }}>Mark as Read</button>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div style={{ padding: '10px', textAlign: 'center', fontSize: '13px', color: '#666' }}>
                      No new notifications
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* <div style={{ display: "flex", gap: "10px" }}>
              <span style={{ fontWeight: "500" }}><p className="my-auto">{t("Language")} :</p></span>
              <button onClick={() => toggleLanguage("en")} style={{background: "rgba(245, 123, 0, 0)", color: "#000000ff", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: "5px", fontWeight: "600"}}>English</button>
              <span>|</span>
              <button onClick={() => toggleLanguage("mr")} style={{background: "rgba(245, 123, 0, 0)", color: "#000000ff", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: "5px", fontWeight: "600"}}>Marathi
              </button>
            </div> */}
          </nav>
          <Outlet />
        </div >
      </div >
    </>
  );
};

export default AdminNavbar;